/**
 * Created by andrey on 20.02.2026
 *
 * https://msstart-games-sdk-doc.azurewebsites.net/docs/sdk-apis/cloud-saves
 * The maximum allowable data size for saving is 1 MB. Works only for logged in users.
 * The data object must consist of flat, single-level key-value pairs. Nested keys or objects are not supported.
 *
 * https://www.msn.com/en-us/play/games/testing/cg-test-game?dev-playground=https://tripeaks-staging.labsystech.ru/publish/html5-staging/msstart
 */

class MSStartTransportAdapter {
    saveData(data, options, onSuccess, onFailure) {
        new ConnectorActionPlayer([
            (f) => {
                if (!options.syncout) {
                    f();
                    return;
                }

                $msstart.cloudSave.getDataAsync({
                    gameId: connector.config.projectId
                }).then((storedData) => {
                    for (const key in storedData) {
                        if (key.startsWith("sync_") && data[key] === undefined) {
                            data[key] = null;
                        }
                    }

                    f();
                }).catch(onFailure);
            },

            (f) => {
                data = SyncTransportUtils.addKeysPrefix("sync_", data);
                data = SyncTransportUtils.serializeValues(data);

                $msstart.cloudSave.saveDataAsync({
                    gameId: connector.config.projectId,
                    data
                }).then(f).catch(onFailure);
            }
        ]).play(onSuccess);
    }

    loadSession(onSuccess, onFailure) {
        this.loadData((data) => onSuccess(data && data.session), onFailure);
    }

    loadData(onSuccess, onFailure) {
        $msstart.cloudSave.getDataAsync({
            gameId: connector.config.projectId
        }).then((data) => {
            data = SyncTransportUtils.removeKeysPrefix("sync_", data);
            data = SyncTransportUtils.deserializeValues(data);

            onSuccess(data);
        }).catch(onFailure);
    }
}